import * as toastr from "toastr";
import CircularSlider from "@fseehawer/react-circular-slider";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { survivalGuideItems } from "source/app/presentation/RadialSurvivalGuide/Helpers/GetSurvivalGuideItemsToDisplay";
import { MathUtils } from "source/app/services/Math/MathUtils";
import { SetState } from "source/app/services/UI/State/SetState";
import { ShareState } from "../../../services/UI/State/ShareState";
import { ReadState } from "../../../services/UI/State/ReadState";
import { NonRepeatingShuffledArray } from "source/app/services/NonRepeatingShuffledArray";

export function DrawSlider({
    setValue,
}: {
    setValue: React.Dispatch<React.SetStateAction<string>>;
}) {
    const [knobColor, setKnobColor] = React.useState<string>(`gold`);
    const [dataIndex, setDataIndex] = React.useState<number>(0);
    const [items, setItems] = React.useState<string[]>(survivalGuideItems);

    ShareState(
        ESharedFunction.RadialSurvivalGuide_dataIndex,
        dataIndex,
        setDataIndex
    );

    ShareState(ESharedFunction.RadialSurvivalGuide_items, items, setItems);

    React.useEffect(() => {
        RandomizeSurvivalGuideSlider();

        if (items.length > maxSurvivalItemsCount) {
            const numItemsToRemove = items.length - maxSurvivalItemsCount;

            toastr.erroring(
                `Please remove ${numItemsToRemove} survival guide items `
            );
        }
    }, []);

    return (
        <CircularSlider
            width={200}
            progressLineCap="flat"
            label="Alphabet"
            data={items}
            labelColor="#212121"
            verticalOffset="1rem"
            knobColor={knobColor}
            dataIndex={dataIndex}
            knobSize={62}
            progressColorFrom={`hsla(53, 54%, 32%, 0.72)`}
            progressColorTo={`hsla(28, 54%, 32%, 0.72)`}
            progressSize={12}
            trackColor={`hsla(28, 54%, 32%, 0.72)`}
            trackSize={12}
            onChange={(value: string) => {
                setValue(value);
                setKnobColor(GetKnobColor());
            }}
            hideLabelValue
        />
    );
}

export function RandomizeSurvivalGuideSlider() {
    const randomItem = shuffledArray.Take(1)[0];

    const itemIndex = survivalGuideItems.findIndex(
        (item) => item === randomItem
    );

    SetState<number>(ESharedFunction.RadialSurvivalGuide_dataIndex, itemIndex);
}

function GetKnobColor() {
    return `hsla(${MathUtils.RandomNumberBetween(32, 54)}, 
                            ${MathUtils.RandomNumberBetween(32, 34)}%,
                            ${MathUtils.RandomNumberBetween(42, 52)}%
                            , 1)`;
}

const shuffledArray = new NonRepeatingShuffledArray(survivalGuideItems);

const maxSurvivalItemsCount = 30;
